/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Digital_BundleInputs */

const en_val_digital_bundle = /** @type {(inputs: Val_Digital_BundleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital Bundle`)
};

/** @type {(inputs: Val_Digital_BundleInputs) => LocalizedString} */
const es_val_digital_bundle = en_val_digital_bundle;

/** @type {(inputs: Val_Digital_BundleInputs) => LocalizedString} */
const fr_val_digital_bundle = en_val_digital_bundle;

/** @type {(inputs: Val_Digital_BundleInputs) => LocalizedString} */
const de_val_digital_bundle = en_val_digital_bundle;

/** @type {(inputs: Val_Digital_BundleInputs) => LocalizedString} */
const ja_val_digital_bundle = en_val_digital_bundle;

/** @type {(inputs: Val_Digital_BundleInputs) => LocalizedString} */
const zh_val_digital_bundle = en_val_digital_bundle;

/** @type {(inputs: Val_Digital_BundleInputs) => LocalizedString} */
const ar_val_digital_bundle = en_val_digital_bundle;

/** @type {(inputs: Val_Digital_BundleInputs) => LocalizedString} */
const id_val_digital_bundle = en_val_digital_bundle;

/** @type {(inputs: Val_Digital_BundleInputs) => LocalizedString} */
const it_val_digital_bundle = en_val_digital_bundle;

/** @type {(inputs: Val_Digital_BundleInputs) => LocalizedString} */
const ru_val_digital_bundle = en_val_digital_bundle;

/** @type {(inputs: Val_Digital_BundleInputs) => LocalizedString} */
const pt_val_digital_bundle = en_val_digital_bundle;

/** @type {(inputs: Val_Digital_BundleInputs) => LocalizedString} */
const ko_val_digital_bundle = en_val_digital_bundle;

/**
* | output |
* | --- |
* | "Digital Bundle" |
*
* @param {Val_Digital_BundleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_digital_bundle = /** @type {((inputs?: Val_Digital_BundleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Digital_BundleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_digital_bundle(inputs)
	if (locale === "es") return es_val_digital_bundle(inputs)
	if (locale === "fr") return fr_val_digital_bundle(inputs)
	if (locale === "de") return de_val_digital_bundle(inputs)
	if (locale === "ja") return ja_val_digital_bundle(inputs)
	if (locale === "zh") return zh_val_digital_bundle(inputs)
	if (locale === "ar") return ar_val_digital_bundle(inputs)
	if (locale === "id") return id_val_digital_bundle(inputs)
	if (locale === "it") return it_val_digital_bundle(inputs)
	if (locale === "ru") return ru_val_digital_bundle(inputs)
	if (locale === "pt") return pt_val_digital_bundle(inputs)
	return ko_val_digital_bundle(inputs)
});